import { useTranslation } from '../../i18n/i18n';
import { renderTemplate } from '../utils';
import { WIZARD_STEPS } from './wizard';
import './WizardStepLabel.css';

/* "Step 2 of 4" in the header of whichever modal the wizard is standing in, and nothing outside it */
export const WizardStepLabel = ({ step }: { step?: number }): JSX.Element => {
	const t = useTranslation().subscriptions.wizard;

	if (!step) return <></>;

	return <span className="wizard-step-label">{renderTemplate(t.step, { current: step, total: WIZARD_STEPS })}</span>;
};
